import type { Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { isArchiveMailboxInfo } from "owa-client-types/lib/ArchiveMailboxInfo";
import { isPublicFolderMailboxInfo } from "owa-client-types/lib/PublicFolderMailboxInfo";
import { isSharedMailboxInfo } from "owa-client-types/lib/SharedMailboxInfo";
import { isSharedMailboxAutomapped } from "owa-account-shared-mailbox-utils";

export const conversationViewCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // by default
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        // We don't support conversation view for the following account types
        // 1. Archive mailbox
        // 2. Public folder mailbox
        // 3. Shared mailbox that is not automapped (for auto mapped, user has full perms and FindConversation API is supported)
        if (mailboxInfo &&
            (isArchiveMailboxInfo(mailboxInfo) ||
                isPublicFolderMailboxInfo(mailboxInfo) ||
                (isSharedMailboxInfo(mailboxInfo) && !isSharedMailboxAutomapped(mailboxInfo)))) {
            return false;
        }
        
        return true;
    },
};
